import {Component, EventEmitter, inject, Input, OnInit, Output} from '@angular/core';
import {NavItem} from './nav-item';
import {NavigationEnd, Router} from '@angular/router';
import {NavService} from '../../../../services/layout/nav.service';
import {MaterialModule} from 'src/app/material.module';
import {CommonModule} from '@angular/common';
import {filter} from 'rxjs/operators';
import {ClientService} from '../../../../services/auth/client.service';
import {PRODUCT_ORDER, productSlugFromType} from '../../../../shared/products';

@Component({
  selector: 'app-nav-item',
  standalone: true,
    imports: [MaterialModule, CommonModule],
  templateUrl: './nav-item.component.html',
  styleUrls: [],
})
export class AppNavItemComponent implements OnInit {
    navService = inject(NavService);
    router = inject(Router);
    private clientService = inject(ClientService);

  @Output() toggleMobileLink: any = new EventEmitter<void>();
  @Output() notify: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input() item: NavItem | any;
  @Input() depth: any;

  activeRoute: string = ''; // Track the current active route

    constructor() {
    if (this.depth === undefined) {
      this.depth = 0;
    }
  }

  ngOnInit() {
    // Set the active route immediately on component initialization
    this.activeRoute = this.router.url;

    // Subscribe to router events to track route changes
    this.router.events
        .pipe(filter((event) => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          this.activeRoute = event.urlAfterRedirects;
        });
  }

    isRouteActive(item: NavItem): boolean {
      const current = this.normaliseRoute(this.activeRoute);
        const itemRoute = item.route;
        if (!itemRoute) return false;

      const target = this.normaliseRoute(itemRoute);

      if (target === '/webinars') {
          if (current === '/webinars') return true;
          if (current.startsWith('/webinars/')) {
              const segments = current.split('/').filter(Boolean);
              const nextSegment = segments[1] || '';
              return nextSegment.length > 0 && nextSegment !== 'settings';
          }
          return false;
      }

      if (current === target) return true;
      return current.startsWith(`${target}/`);
  }

    private normaliseRoute(route: string): string {
        const [path] = route.split('?');
        const cleanPath = path.split('#')[0];
        return cleanPath.endsWith('/') && cleanPath !== '/' ? cleanPath.slice(0, -1) : cleanPath;
  }

  onItemSelected(item: NavItem) {
      const normalizedProduct = PRODUCT_ORDER.find(product => product === item.productType);
      if (item.productType && item.productType !== 'all'
          && (!normalizedProduct || !this.clientService.hasProductAccessContext())) {
          return;
      }
      if (normalizedProduct && this.clientService.getActiveProduct() !== normalizedProduct) {
          this.clientService.setActiveProduct(normalizedProduct);
      }

      const targetRoute = this.getLandingRouteForItem(item) || item.route || '/';
      this.router.navigate([targetRoute]); // Navigate to the clicked route

    // Scroll to the top of the page
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }

    onSubItemSelected(_item: NavItem) {
    // Handle sub-item selection if needed
  }

    private getLandingRouteForItem(item: NavItem): string | null {
        if (!item.productType || item.productType === 'all' || this.clientService.canAccessProduct(item.productType)) {
            return null;
        }

        const slug = productSlugFromType(item.productType);
        return `/products/${slug}/landing`;
    }
}
